export default safe => {
  console.log(safe); //vue的this对象
  return {
    lazy: true,
    tip: false,
    simplePage: true,
    searchShow: true,
    // searchMenuSpan: 6,
    tree: true,
    border: true,
    /** 表格索引 */
    index: false,
    /** 表格搜索显隐按钮 */
    searchShowBtn: true,
    /** 是否启用功能按钮 */
    searchIcon: true,
    searchIndex: 0,
    /** 表格查看按钮 */
    viewBtn: false,
    /** 表格新增按钮 */
    addBtn: false,
    /** 表格删除按钮 */
    delBtn: false,
    /** 表格修改按钮 */
    editBtn: false,
    /** 导出按钮 */
    excelBtn: true,
    /** 表格搜索按钮 */
    // searchBtn: false,
    /** 表格清空按钮 */
    // emptyBtn: false,
    /** 开启拖拽功能 */
    // sortable: true,
    // dragHandler: true,
    // rowSort: true,
    // columnSort: true,
    menuWidth: 100,
    column: [
      {
        label: "ID",
        prop: "id",
        /** 当内容过长被隐藏时显示 tooltip */
        overHidden: false,
        // search: true,
        columnBtn: false
        /** 搜索项位置排序，序号越大越靠前 */
        // searchOrder: 1,
      },
      {
        label: "收款商户",
        prop: "payee",
        /** 当内容过长被隐藏时显示 tooltip */
        overHidden: false
        // slot: true
        // search: true,
        /** 搜索项位置排序，序号越大越靠前 */
        // searchOrder: 1,
      },
      {
        label: "订单编号",
        prop: "payOrderNo",
        width: 190
      },
      {
        label: "商户单号",
        prop: "payChargeNo",
        width: 150
      },
      {
        label: "交易流水号",
        prop: "paySerialNo",
        width: 210
      },
      {
        label: "来源渠道",
        prop: "channelId",
        slot: true,
        overHidden: true
      },
      {
        label: "媒资内容",
        prop: "mediaContent",
        overHidden: true,
        slot: true
      },
      {
        label: "媒资ID",
        prop: "mediaId"
      },
      {
        label: "媒资来源",
        prop: "partnerName"
      },
      {
        label: "媒资类型",
        prop: "mediaType",
        slot: true
      },
      {
        label: "媒资有效期",
        prop: "validStartTime",
        slot: true,
        width: 280
      },
      {
        label: "用户账号",
        prop: "username",
        width: 100
      },
      {
        label: "下单时间",
        prop: "addTime",
        width: 160
      },
      {
        label: "原价（元）",
        prop: "formerPrice"
      },
      {
        label: "折扣价",
        prop: "payPrice"
      },
      {
        label: "订单数量",
        prop: "payNum"
      },
      {
        label: "支付金额（元）",
        prop: "payMoney"
      },
      {
        label: "支付时间",
        prop: "payTime",
        width: 160
      },
      {
        label: "支付方式",
        prop: "payMethod",
        dicData: [
          {
            label: "微信",
            value: 1
          },
          {
            label: "支付宝",
            value: 2
          }
        ]
      },
      {
        label: "订单状态",
        prop: "payStatus",
        dicData: [
          {
            label: "未支付",
            value: 0
          },
          {
            label: "已支付",
            value: 1
          },
          {
            label: "支付失败",
            value: 2
          }
        ]
      },
      {
        label: "退款时间",
        prop: "refundTime",
        slot: true,
        width: 160
      },
      {
        label: "退款状态",
        prop: "refundStatus",
        slot: true
      },
      // {
      //   label: "备注",
      //   slot: true,
      //   prop: "refundReason"
      // },
      {
        label: "",
        prop: "my",
        hide: true,
        showColumn: false,
        search: true,
        display: false,
        menuClassName: "myClass",
        searchslot: true
      }
    ]
  };
};
